import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTUREDASHBOARD,
    RETRIEVE_ARCHITECTUREDASHBOARD,
    RETRIEVESINGLE_ARCHITECTUREDASHBOARD,
    UPDATE_ARCHITECTUREDASHBOARD,
    DELETE_ARCHITECTUREDASHBOARD,
} from "./type";
import ARCDashboard from "../service/dashboard";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCDashboard.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCDashboard.create(data);
        dispatch({
            type: CREATE_ARCHITECTUREDASHBOARD,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCDashboard.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTUREDASHBOARD,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCDashboard.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTUREDASHBOARD,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCDashboard.update(data);
        dispatch({
            type: UPDATE_ARCHITECTUREDASHBOARD,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCDashboard.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTUREDASHBOARD,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCDashboard.trash(data);
        dispatch({
            type: DELETE_ARCHITECTUREDASHBOARD,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};